<template>
	<div class="accordion">
		<div class="accordion-header">
			<slot name="header" :visible="model" :toggle>
				<UIShButton label="Toggle" />
			</slot>
		</div>

		<Transition name="slide-top">
			<div v-if="model">
				<slot name="body" />
			</div>
		</Transition>
	</div>
</template>

<script setup lang="ts">
import { UIShButton } from '#components';

const model = defineModel<boolean>({ default: false });

function toggle() {
	model.value = !model.value;
}
</script>

<style lang="scss" scoped>
.accordion {
	border-radius: 0.889rem;
	background-color: var(--color-gray50);
}

.accordion-header {
	padding: 0.889rem;
}

@include screen1920 {
	.accordion {
		border-radius: 1.111rem;
	}

	.accordion-header {
		padding: 1.111rem;
	}
}
</style>
